module.exports = __webpack_public_path__ + "img/dw.c299c007.png";